AU.databox_legacy = {
    mobile: false,
    options: {
        config: {
            container: '.au_databox',
            width: null,
            firstline: true,
            alphabet: 2,
            initLetter: 'a',
            trigger: 0,
            expand: false,
            tracking: '/virtual/databox/',
            burger: false,
            rememberState: false
        },
        background: {
            color: '#003d73',
            src: '',
            height: 0,
            text: '',
            overlay: true
        },
        search: {
            autocomplete: true,
            index: 1,
            minLength: 1,
            placeHolder: '',
            more: '',
            moreText: '',
            initValue: ''
        },
        data: {
            mode: 'list',
            source: '.au_databox_list',
            itemsOnly: false,
            callback: null,
            sortAssocs: false
        }
    },
    boxes: [],
    mergeOptions: function (box) {
        if (!box.hasOwnProperty('config')) {
            box.config = {};
        }

        for (var conf in this.options.config) {
            if (!box.config.hasOwnProperty(conf)) {
                box.config[conf] = this.options.config[conf];
            }
        }

        if (!box.hasOwnProperty('background')) {
            box.background = {};
        }

        for (var bg in this.options.background) {
            if (!box.background.hasOwnProperty(bg)) {
                box.background[bg] = this.options.background[bg];
            }
        }

        if (!box.hasOwnProperty('search')) {
            box.search = {};
        }

        for (var sch in this.options.search) {
            if (!box.search.hasOwnProperty(sch)) {
                box.search[sch] = this.options.search[sch];
            }
        }

        if (!box.hasOwnProperty('data')) {
            box.data = {};
        }

        for (var data in this.options.data) {
            if (!box.data.hasOwnProperty(data)) {
                box.data[data] = this.options.data[data];
            }
        }
    },
    createMarkup: function (box) {

        var container = jQuery(box.config.container).eq(0);
        var headers = jQuery('> *:not(.no-header)', container);

        headers.each(function (i) {
            var index = i + 1;
            var me = jQuery(this);
            me.addClass('db-button').addClass('button-' + index).attr('data-index', index).wrapInner('<span />');

            var search = box.search;
            if (search.index === index) {
                me.addClass('db-search');
                if (!box.search.autocomplete) {
                    me.addClass('search-filter');
                }
                jQuery('span', me).after('<input type="text" placeholder="' + search.placeHolder + '" />');
            }

        });

        container.addClass('buttons-' + headers.length).wrapInner('<div class="button-wrapper"><div></div></div>').append('<div class="content" />');

        if (box.config.width !== null) {
            container.css('width', box.config.width);
        }

        if (box.config.firstline) {
            container.addClass('first-line-full');
        }

        for (var i = 1; i <= headers.length; i++) {
            jQuery('.content', container).append('<div class="content-' + i + '" data-index="' + i + '">Dummy content ' + i + '</div>');
        }

        var buttonWrapper = jQuery('.button-wrapper', container);
        var background = box.background;
        if (background.src !== "") {
            buttonWrapper.css('background', background.color + " url('" + background.src + "')");
        } else {
            if (!container.hasClass('stacked')) {
                buttonWrapper.css('background-color', background.color);
            }
        }

        if (background.height > 0) {
            buttonWrapper.height(background.height);
            if (background.overlay) {
                headers.addClass('overlay');
            }
        }

        if (background.text !== "") {
            var focus = jQuery('<div />', {
                'class': 'au_focus',
                'html': background.text
            });

            buttonWrapper.prepend(focus);
        }

        box.container = container;
        box.headers = headers;
        box.content = jQuery('.content', container);
    },
    alterMarkupForResponsive: function (box) {

        var state = AU.responsive.state;
        var buttonWrapper = jQuery('.button-wrapper', box.container);
        var focus = jQuery('.au_focus', box.container);

        if (focus.length > 0) {

            if (state.NAME === "PHONE") {
                focus.hide();

                var beforeStyle = "";
                if (box.background.src === "") {
                    beforeStyle = 'background-color: ' + box.background.color;
                } else {
                    beforeStyle = "background-image: url('" + box.background.src + "')";
                }

                box.container.prepend('<div class="before au_focus" style="' + beforeStyle + '">' + focus.html() + '<div class="clear" /></div>');
                buttonWrapper.css('height', '');
                box.headers.removeClass('overlay');
            } else {
                if (AU.responsive.stateHistory.length > 1) {
                    focus.show();
                    jQuery('.button-wrapper', box.container).after(box.content);
                    jQuery('.before', box.container).remove();
                    buttonWrapper.height(box.background.height);
                    if (box.background.overlay) {
                        box.headers.addClass('overlay');
                    }
                }
            }
        }

        var content = jQuery('.content', box.container);

        if (state.NAME === "PHONE") {
            jQuery('h2.active', box.container).after(content);
            buttonWrapper.addClass('mobile');
            AU.databox_legacy.mobile = true;
        } else {
            jQuery('.button-wrapper', box.container).after(content);
            buttonWrapper.removeClass('mobile');
            AU.databox_legacy.mobile = false;
        }

        this.resizeFunc(box);
    },
    setFolding: function (box) {
        if (typeof box.container !== "undefined") {

            var headers = box.search.autocomplete ? box.headers.not('.db-search') : box.headers;

            headers.click(function () {

                var me = jQuery(this);
                var index = me.data('index');
                var searchInput = jQuery('input[type=text]', me);

                if (me.hasClass('active')) {

                    if (box.search.autocomplete || searchInput.val() !== "") {

                        if (AU.databox_legacy.mobile || box.config.burger) {
                            box.content.hide();
                            box.headers.removeClass('active');
                            jQuery('#au_shortcuts .last.firstrow').removeClass('extra-height');
                        } else {
                            box.content.hide();
                            box.headers.removeClass('active');
                        }
                    } else {
                        box.headers.removeClass('active');
                    }

                    if (box.config.rememberState && window.sessionStorage) {
                        sessionStorage.removeItem('box-header-' + box.id, null);
                    }

                } else {
                    box.headers.not(me).removeClass('active');
                    me.addClass('active');

                    jQuery('> div[data-index!="' + index + '"]', box.content).hide();
                    jQuery('> div[data-index="' + index + '"]', box.content).show();

                    if (box.search.autocomplete || searchInput.val() !== "") {
                        if (AU.databox_legacy.mobile || box.config.burger) {
                            me.after(box.content);
                            box.content.show();
                            jQuery('#au_shortcuts .last.firstrow').addClass('extra-height');
                        } else {
                            box.content.show();
                        }
                    } else if (searchInput.val() === "") {
                        box.content.hide();
                    }

                    if (me.hasClass('search-filter')) {
                        searchInput.focus();
                    }

                    if (box.config.rememberState && window.sessionStorage) {
                        sessionStorage.setItem('box-header-' + box.id, index);
                    }
                }


            });
        }
    },
    setExpandAll: function (content, expandNow) {
        var expStr = AU.pageLang === "da" ? "Fold alle ud" : "Expand all";
        var clpStr = AU.pageLang === "da" ? "Fold alle ind" : "Collapse all";

        content.append(jQuery('<span />', {
            'class': 'expandall ' + (expandNow ? 'expanded' : 'collapsed'),
            'text': expandNow ? clpStr : expStr
        }));

        jQuery('.expandall', content).click(function () {

            var me = jQuery(this);
            if (me.hasClass('collapsed')) {
                jQuery('.treetable', content).treetable('expandAll');
                me.text(clpStr);
                me.removeClass('collapsed').addClass('expanded');
            } else {
                jQuery('.treetable', content).treetable('collapseAll');
                me.text(expStr);
                me.removeClass('expanded').addClass('collapsed');
            }


        });
    },
    data: {
        get: function (box) {
            if (typeof box.container !== "undefined" && box.container.length > 0) {

                var search = jQuery('.content-' + box.search.index, box.container);
                var alphabet = jQuery('.content-' + box.config.alphabet, box.container);
                var contents = jQuery('.content > div', box.container).not(alphabet).not(search);

                var parseList = function (source) {
                    var list = jQuery(source);
                    var items = [];
                    jQuery.each(jQuery('li', list), function (i) {
                        items.push({
                            id: i,
                            label: jQuery(this).text(),
                            value: jQuery(this).text(),
                            name: jQuery(this).text(),
                            url: jQuery('a', this).attr('href'),
                            children: [],
                            associations: []
                        });
                    });

                    list.hide();
                    return items.sort(AU.databox_legacy.helpers.sortAlphaObj);
                };

                var parseXML = function (source, callback) {

                    var xmlFunc = function (data) {
                        var items = [];
                        var children = [];
                        var associations = [];

                        var assocXML = [];
                        var count = 1;

                        do {
                            assocXML = jQuery(data).find('associations' + count + ' > item');

                            var assoc = [];
                            for (var i = 0; i < assocXML.length; i++) {
                                assoc.push({
                                    id: jQuery(assocXML[i]).attr('id'),
                                    name: jQuery(assocXML[i]).attr('name'),
                                    items: []
                                });
                            }

                            if (assoc.length > 0) {
                                associations.push(assoc);
                            }

                            count++;
                        } while (assocXML.length > 0);

                        var itemsXML = jQuery(data).find('items > item');
                        jQuery.each(itemsXML, function () {
                            var extraXML = jQuery(this).find('extra');
                            var extra = [];
                            jQuery.each(extraXML.find('param'), function () {
                                extra.push({
                                    param: jQuery(this).text()
                                });
                            });
                            var obj = {
                                id: jQuery(this).attr('id'),
                                name: jQuery(this).attr('name'),
                                url: jQuery(this).attr('url'),
                                parent: jQuery(this).attr('parent'),
                                extra: extra,
                                children: [],
                                associations: []
                            };

                            for (var i = 0; i < associations.length; i++) {
                                var objAssoc = jQuery(this).find('association' + parseInt(i + 1));

                                obj.associations.push([]);

                                for (var j = 0; j < objAssoc.length; j++) {
                                    var id = parseInt(jQuery(objAssoc[j]).attr('id')) - 1;
                                    obj.associations[i].push({
                                        id: associations[i][id].id,
                                        name: associations[i][id].name
                                    });
                                    associations[i][id].items.push(obj);
                                }
                            }

                            items.push(obj);
                            if (typeof obj.parent !== "undefined" && obj.parent !== "") {
                                children.push(obj);
                            }
                        });

                        for (var c = 0; c < children.length; c++) {
                            var pid = children[c].parent;
                            for (var p = 0; p < items.length; p++) {
                                if (items[p].id === pid) {
                                    items[p].children.push(children[c]);
                                    break;
                                }
                            }
                        }

                        callback(data, items.sort(AU.databox_legacy.helpers.sortAlphaObj), associations);
                    };

                    AU.helpers.getXML(source, function (data) {
                        xmlFunc(data);
                    });
                };

                var parseJSON = function (source, itemsOnly, callback) {

                    var url = '//typo3.au.dk/widgets/sortingbox/json.php?listid=' + source + (itemsOnly ? '&itemsonly' : '');

                    if ((source + "").indexOf('webtools') > -1) {
                        url = source;
                    }

                    var parse = function (data) {
                        var associations = [];
                        if (typeof data.groupings !== "undefined") {
                            for (var i = 0; i < data.groupings.length; i++) {
                                associations.push(data.groupings[i].associations);
                            }
                        }

                        var items = data.items.sort(AU.databox_legacy.helpers.sortAlphaObj);
                        callback(data, items, associations);
                    };

                    var ieVersion = AU.helpers.getInternetExplorerVersion();
                    if (ieVersion > 6 && ieVersion < 10) {
                        var xdr = window.XDomainRequest ? new XDomainRequest() : null;
                        if (xdr !== null) {
                            xdr.onload = function () {
                                parse(jQuery.parseJSON(xdr.responseText));
                            };

                            xdr.onprogress = function () {
                            };

                            xdr.open('get', url);
                            xdr.send();
                        }

                        jQuery('.ie-remove').removeClass('ie-remove');

                    } else {
                        jQuery.getJSON(url, function (data) {
                            parse(data);
                        });
                    }
                };

                var parseTable = function (source) {
                    var table = jQuery(source + ' > table');
                    var list = jQuery(source + ' > ul');

                    var items = [];
                    var children = [];
                    var associations = [];

                    jQuery('li', list).each(function () {
                        var assoc = [];

                        jQuery('> ul > li', this).each(function (i) {
                            assoc.push({
                                id: i,
                                name: jQuery(this).text(),
                                items: []
                            });
                        });

                        if (assoc.length > 0) {
                            associations.push(assoc);
                        }

                    });

                    jQuery.each(jQuery('tr', table), function (i) {

                        if (i > 0) {


                            var cells = jQuery('td', this);

                            var id = parseInt(cells.eq(0).text());
                            var parent = parseInt(cells.eq(1).text());
                            var name = cells.eq(2).text();
                            if (typeof String.prototype.trim === "function") {
                                name = name.trim();
                            }
                            var url = jQuery('a', cells.eq(2)).attr('href');
                            var skip = 3; // Antallet af celler, som ikke angiver associations!

                            var obj = {
                                id: id,
                                name: name,
                                url: url,
                                parent: parent,
                                extra: [],
                                children: [],
                                associations: []
                            };

                            for (var j = 0; j < associations.length; j++) {
                                var assocCell = cells.eq(j + skip).text();
                                var assocCellSplit = assocCell.split(',');

                                obj.associations.push([]);

                                for (var k = 0; k < assocCellSplit.length; k++) {
                                    var aid = parseInt(assocCellSplit[k]) - 1;

                                    if (typeof associations[j][aid] !== "undefined") {
                                        obj.associations[j].push({
                                            id: associations[j][aid].id,
                                            name: associations[j][aid].name
                                        });

                                        associations[j][aid].items.push(obj);
                                    }
                                }
                            }

                            if (obj.parent === 0 || obj.parent === "") {
                                items.push(obj);
                            } else {
                                children.push(obj);
                            }
                        }
                    });

                    for (var c = 0; c < children.length; c++) {
                        var pid = children[c].parent;
                        for (var p = 0; p < items.length; p++) {
                            if (items[p].id === pid) {
                                items[p].children.push(children[c]);
                                break;
                            }
                        }
                    }

                    table.hide();
                    list.hide();
                    return {
                        items: items.sort(AU.databox_legacy.helpers.sortAlphaObj),
                        associations: associations
                    };
                };

                switch (box.data.mode) {
                    case 'json':
                        parseJSON(box.data.source, box.data.itemsOnly, function (data, items, associations) {

                            AU.databox_legacy.data.apply(box, contents, items, associations, alphabet);
                            AU.databox_legacy.data.setSearch(box, items);

                            if (typeof box.data.callback === "function") {
                                box.data.callback(data);
                            }
                        });
                        break;
                    case 'xml':
                        parseXML(box.data.source, function (data, items, associations) {

                            AU.databox_legacy.data.apply(box, contents, items, associations, alphabet);
                            AU.databox_legacy.data.setSearch(box, items);

                            if (typeof box.data.callback === "function") {
                                box.data.callback(data);
                            }

                        });
                        break;
                    case 'list':
                        var items = parseList(box.data.source);
                        this.apply(box, contents, items, [], alphabet);
                        this.setSearch(box, items);
                        break;
                    case 'table':
                        var ia = parseTable(box.data.source);
                        this.apply(box, contents, ia.items, ia.associations, alphabet);
                        this.setSearch(box, ia.items);
                        break;
                    default:
                        break;
                }
            }
        },
        setSearch: function (box, items) {

            var search = jQuery('.db-search > input[type="text"]', box.container);

            if (box.search.autocomplete && search.length > 0) {

                search.autocomplete({
                    source: function (request, response) {
                        var matcher = new RegExp(jQuery.ui.autocomplete.escapeRegex(request.term), 'i');
                        response(jQuery.grep(jQuery.map(items, function (key) {
                            return {
                                id: key.id,
                                label: key.name,
                                value: key.name,
                                url: key.url
                            };
                        }), function (value) {
                            value = value.label || value.value || value;
                            return matcher.test(value) || matcher.test(AU.helpers.normalizeAccents(value));
                        }));
                    },
                    minLength: box.search.minLength,
                    autoFocus: true,
                    delay: 0,
                    open: function () {
                        if (box.search.more !== "") {
                            var li = jQuery('<li />', {
                                'class': 'ui-menu-item',
                                'role': 'menuitem'
                            });

                            var a = jQuery('<a />', {
                                'class': 'ui-corner-all more',
                                'tabindex': -1,
                                'html': (box.search.moreText === "" ? AU.pageLang === "da" ? 'Komplet oversigt' : 'Complete list' : box.search.moreText) + ' &raquo;'
                            });

                            a.click(function () {
                                location.href = box.search.more;
                            });

                            a.appendTo(li);
                            jQuery('ul.ui-autocomplete').append(li);
                        }
                    },
                    select: function (e, ui) {
                        if (typeof ui.item.url !== "undefined") {

                            var append = "";
                            if (ui.item.url.indexOf('http')) {
                                append = "/";
                            }
                            location.href = append + ui.item.url;
                        } else {
                            jQuery('.button-' + box.config.alphabet, box.container).trigger('click');
                            var parentFirstLetter = ui.item.value.substring(0, 1).toLowerCase();
                            jQuery('.listNav .' + parentFirstLetter).trigger('click');

                            AU.helpers.scrollToElement(box.config.container + ' .content', "span[name='alpha-anchor-" + ui.item.id + "']");
                        }
                    }
                }).data('ui-autocomplete')._renderItem = function (ul, item) {
                    return jQuery('<li />').data('ui-autocomplete-item', item).append('<a class="ui-corner-all" href="' + item.url + '">' + item.label + '</a>').appendTo(ul);
                };

            } else {
                box.filterItems = items;
                search.on('keyup', function () {
                    AU.databox_legacy.data.searchFilter(jQuery(this).val(), box);
                });
            }

            search.on('keyup', function () {
                var ln = jQuery(this).val().length;
                if (ln > 0) {
                    jQuery(this).addClass('active');
                } else {
                    jQuery(this).removeClass('active');
                }

                if (window.sessionStorage && box.config.rememberState) {
                    sessionStorage.setItem('box-search-' + box.id, jQuery(this).val());
                }
            });

            if (box.search.initValue !== '') {
                search.val(box.search.initValue);
                search.focus();

                if (box.search.autocomplete) {
                    var keyEvent = box.search.autocomplete ? jQuery.Event('keydown') : jQuery.Event('keyup');
                    keyEvent.keyCode = jQuery.ui.keyCode.DOWN;
                    search.trigger(keyEvent);
                } else {
                    this.searchFilter(search.val(), box);
                    box.headers.eq(box.search.index - 1).trigger('click');
                }
            }
        },
        searchFilter: function (query, box) {
            if (query === "") {
                box.content.hide();
            } else {

                var searchContent = jQuery('.content-' + box.search.index, box.container);

                var filteredItems = AU.databox_legacy.data.filterItems(query, box);
                var html = "";

                if (filteredItems.length > 0) {
                    html += "<ul>";
                    for (var i = 0; i < filteredItems.length; i++) {
                        var item = filteredItems[i];
                        html += '<li><a href="' + item.url + '">' + item.name + '</a></li>';
                    }
                    html += "</ul>";
                } else {
                    html += AU.pageLang === "da" ? "Ingen resultater fundet." : "No results found.";
                }

                searchContent.html(html);
                if (AU.databox_legacy.mobile) {
                    jQuery('.button-' + box.search.index, box.container).after(box.content);
                }
                box.content.show();
            }
        },
        filterItems: function (query, box) {
            var filtered = [];
            if (typeof box.filterItems !== "undefined" && typeof query !== "undefined") {
                query = query.toLowerCase();
                for (var i = 0; i < box.filterItems.length; i++) {
                    var name = box.filterItems[i].name.toLowerCase();
                    if (name.indexOf(query) > -1 || AU.helpers.normalizeAccents(name).indexOf(query) > -1) {
                        filtered.push(box.filterItems[i]);
                    }
                }
            }
            return filtered;
        },
        apply: function (box, contents, items, associations, alphabet) {

            if (associations.length > 0 && items.length > 0) {
                this.generateTreeTableListings(box.id, associations, contents, box.config.expand, box.data.sortAssocs, box.config.rememberState);
            }

            if (items.length > 0) {
                alphabet.empty();
                this.generateAlphabeticalListing(box.id, items, alphabet, box.config.initLetter);
            }
        },
        generateAlphabeticalListing: function (id, items, alphabet, initLetter) {
            var alphabetList = '<div class="listNav" id="alphabet_' + id + '-nav" /><ul id="alphabet_' + id + '">';
            for (var i = 0; i < items.length; i++) {
                if (typeof items[i].parent === "undefined" || items[i].parent === "" || items[i].parent === 0) {
                    alphabetList += "<li>" + (typeof items[i].url === "undefined" ? ("<span name=\"alpha-anchor-" + items[i].id + "\">" + items[i].name + "</span>") : "<a href=\"" + items[i].url + "\">" + items[i].name + "</a>");

                    if (typeof items[i].extra !== "undefined" && items[i].extra.length > 0) {
                        alphabetList += "<br />";
                        for (var k = 0; k < items[i].extra.length; k++) {
                            alphabetList += items[i].extra[k].param + ", ";
                        }
                        alphabetList = alphabetList.substring(0, alphabetList.length - 2);
                    }

                    if (items[i].children.length > 0) {
                        items[i].children = items[i].children.sort(AU.databox_legacy.helpers.sortAlphaObj);
                        alphabetList += "<ul>";
                        for (var c = 0; c < items[i].children.length; c++) {
                            alphabetList += "<li>" + (typeof items[i].children[c].url === "undefined" ? items[i].children[c].name : "<a href=\"" + items[i].children[c].url + "\">" + items[i].children[c].name + "</a>");

                            if (typeof items[i].children[c].extra !== "undefined" && items[i].children[c].extra.length > 0) {

                                alphabetList += "<br />";

                                for (var g = 0; g < items[i].children[c].extra.length; g++) {
                                    alphabetList += items[i].children[c].extra[g].param + ", ";
                                }
                                alphabetList = alphabetList.substring(0, alphabetList.length - 2);
                            }

                            alphabetList += "</li>";
                        }
                        alphabetList += "</ul>";
                    }
                    alphabetList += "</li>";
                }
            }

            alphabetList += "</ul>";

            alphabet.append(alphabetList);
            jQuery('#alphabet_' + id).listnav({
                showCounts: false,
                initLetter: initLetter
            });

            jQuery('#alphabet_' + id + '-nav .ln-letters a').on('click', function () {

            });

            if (window.sessionStorage) {
                jQuery('#alphabet_' + id + '-nav .ln-letters a').click(function () {
                    sessionStorage.setItem('box-alphabet-' + id, jQuery(this).text());
                });
            }


        },
        sortAssocs: function (associations) {

            for (var i = 0; i < associations.length; i++) {
                associations[i] = associations[i].sort(AU.databox_legacy.helpers.sortAlphaObj);
            }

            return associations;
        },
        generateTreeTableListings: function (id, associations, contents, expandNow, sortAssocs, rememberState) {

            if (sortAssocs) {
                this.sortAssocs(associations);
            }

            var setCollapseClick = function (id, index, content, rememberState) {
                jQuery('tr.branch', content).on('click', function () {

                    if (rememberState) {

                        if (jQuery(this).hasClass('expanded')) {
                            sessionStorage.setItem('box-tree-' + id + '-' + index, jQuery(this).data('tt-id'));
                        } else {
                            sessionStorage.removeItem('box-tree-' + id + '-' + index);
                        }

                    }


                });
            };

            var openTree = function (node) {
                var tree = jQuery('.treetable', contents.eq(i));
                if (tree.length > 0) {
                    var rows = jQuery('tr[data-tt-parent-id="' + node + '"]');
                    if (rows.length > 0) {
                        tree.treetable('expandNode', node);
                        rows.css('display', 'table-row');
                        jQuery('.indenter', rows).css('padding-left', '19px');
                    }
                }
            };

            for (var i = 0; i < associations.length; i++) {

                var tableContent = "";
                for (var j = 0; j < associations[i].length; j++) {
                    if (associations[i][j].items.length > 0) {
                        var sortItems = associations[i][j].items.sort(AU.databox_legacy.helpers.sortAlphaObj);
                        tableContent += '<tr data-tt-id="' + id + '.' + parseInt(i + 1) + '.' + j + '">';
                        tableContent += "<td><strong>" + associations[i][j].name + "</strong></td>";
                        tableContent += "</tr>";
                        for (var n = 0; n < sortItems.length; n++) {

                            if (typeof sortItems[n].parent === "undefined" || sortItems[n].parent === "" || sortItems[n].parent === 0) {

                                tableContent += '<tr data-tt-id="' + id + '.' + parseInt(i + 1) + '.' + j + '.' + n + '" data-tt-parent-id="' + id + '.' + parseInt(i + 1) + '.' + j + '">';

                                tableContent += typeof sortItems[n].url === "undefined" ? '<td>' + sortItems[n].name : '<td><a href="' + sortItems[n].url + '">' + sortItems[n].name + '</a>';
                                if (typeof sortItems[n].extra !== "undefined" && sortItems[n].extra.length > 0) {
                                    tableContent += "<br />";
                                    for (var k = 0; k < sortItems[n].extra.length; k++) {
                                        tableContent += sortItems[n].extra[k].param + ", ";
                                    }
                                    tableContent = tableContent.substring(0, tableContent.length - 2);
                                }
                                if (sortItems[n].children.length > 0) {
                                    sortItems[n].children = sortItems[n].children.sort(AU.databox_legacy.helpers.sortAlphaObj);
                                    tableContent += "<ul>";
                                    for (var h = 0; h < sortItems[n].children.length; h++) {
                                        var childHasAssoc = false;
                                        if (typeof sortItems[n].children[h].associations[i] !== "undefined") {
                                            for (var q = 0; q < sortItems[n].children[h].associations[i].length; q++) {
                                                if (sortItems[n].children[h].associations[i][q].id === associations[i][j].id) {
                                                    childHasAssoc = true;
                                                    break;
                                                }
                                            }
                                        }

                                        if (childHasAssoc) {
                                            tableContent += typeof sortItems[n].children[h].url === "undefined" ? '<li>' + sortItems[n].children[h].name : '<li><a href="' + sortItems[n].children[h].url + '">' + sortItems[n].children[h].name + '</a>';
                                            if (typeof sortItems[n].children[h].extra !== "undefined" && sortItems[n].children[h].extra.length > 0) {
                                                tableContent += "<br />";
                                                for (var p = 0; p < sortItems[n].children[h].extra.length; p++) {
                                                    tableContent += sortItems[n].children[h].extra[p].param + ", ";
                                                }
                                                tableContent = tableContent.substring(0, tableContent.length - 2);
                                            }
                                            tableContent += '</li>';
                                        }
                                    }
                                    tableContent += '</ul>';
                                }
                                tableContent += '</td>';
                                tableContent += '</tr>';
                            }
                        }
                    }
                }

                contents.eq(i).empty();

                jQuery('<table />', {
                    id: 'au_databox_association_' + id + '_' + parseInt(i + 1),
                    html: tableContent
                }).appendTo(contents.eq(i)).treetable({
                    clickableNodeNames: true,
                    expandable: true,
                    initialState: expandNow ? 'expanded' : 'collapsed'
                });

                setCollapseClick(id, i, contents.eq(i), window.sessionStorage && rememberState);

                if (window.sessionStorage && rememberState) {

                    setCollapseClick(id, i, contents.eq(i));

                    var ssTree = sessionStorage.getItem('box-tree-' + id + '-' + i);
                    if (ssTree !== null) {
                        openTree(ssTree);
                    }

                    var dl = AU.helpers.getQuerystring('node');
                    if (dl !== "") {
                        openTree(dl);
                    }
                }

                if (associations[i].length > 1) {
                    AU.databox_legacy.setExpandAll(contents.eq(i), expandNow);
                }
            }
        }
    },
    helpers: {
        sortAlpha: function (a, b) {
            return jQuery(a).text().toLowerCase() > jQuery(b).text().toLowerCase() ? 1 : -1;
        },
        sortAlphaObj: function (a, b) {
            if (typeof a.name !== "undefined" && typeof b.name !== "undefined") {
                return a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1;
            }
            return 0;
        }
    },
    resizeTextFields: function (box) {
        var searchFields = jQuery('input[type=text]', box.container);
        jQuery.each(searchFields, function () {
            var parent = jQuery(this).parent();
            var width = parent.width() - parent.css('text-indent').replace('px', '') - jQuery(this).css('left').replace('px', '') - 2;
            jQuery(this).css('width', width + 'px');
        });
    },
    resizeFunc: function (box) {
        this.resizeTextFields(box);

        AU.addResizeFunction(function () {
            AU.databox_legacy.resizeTextFields(box);
        });
    },
    firstLoad: false,
    init: function () {

        var qsInit = decodeURI(AU.helpers.getQuerystring('initval'));

        for (var i = 0; i < this.boxes.length; i++) {

            var box = this.boxes[i];

            if (typeof box.loaded === "undefined") {
                box.id = i;

                if (window.sessionStorage && box.config.rememberState) {
                    var ssBox = sessionStorage.getItem('box-header-' + i);
                    if (ssBox === null) {
                        ssBox = AU.helpers.getQuerystring('box');
                    }
                    var ssSearch = sessionStorage.getItem('box-search-' + i);
                    var ssAlpha = sessionStorage.getItem('box-alphabet-' + i);
                    if (ssBox !== null && ssBox !== "") {
                        box.config.trigger = parseInt(ssBox);
                    }

                    if (ssSearch !== null && qsInit === "") {
                        box.search.initValue = ssSearch;
                    }

                    if (ssAlpha !== null) {
                        box.config.initLetter = ssAlpha;
                    }
                }

                this.mergeOptions(box);
                this.createMarkup(box);
                this.setFolding(box);

                if (i === 0 && qsInit !== "") {
                    box.search.initValue = qsInit;
                }

                this.data.get(box);

                if (box.config.trigger > 0 && !AU.databox_legacy.mobile) {
                    box.headers.eq(box.config.trigger - 1).trigger('click');
                }

                this.resizeFunc(box);

                box.loaded = true;

            }

        }

        if (!this.firstLoad) {

            if (typeof AU.responsive !== "undefined") {

                AU.responsive.markupRenderFunctions.push(function () {
                    for (var i = 0; i < AU.databox_legacy.boxes.length; i++) {
                        AU.databox_legacy.alterMarkupForResponsive(AU.databox_legacy.boxes[i]);
                    }
                });
            }

            this.firstLoad = true;

        }
    }
};

(function(a){a.fn.listnav=function(b){var d=a.extend({},a.fn.listnav.defaults,b);var e;if(AU.pageLang==="da"){e=["_","a","b","c","d","e","f","g","h","i","j","k","l","m","n","o","p","q","r","s","t","u","v","w","x","y","z","æ","ø","å","-"]}else{e=["_","a","b","c","d","e","f","g","h","i","j","k","l","m","n","o","p","q","r","s","t","u","v","w","x","y","z","-"]}var c=false;d.prefixes=a.map(d.prefixes,function(f){return f.toLowerCase()});return this.each(function(){var t,v,f,n,k,q;q=this.id;t=a("#"+q+"-nav");f=a(this);var x={},i=0,j=true,h=0,w="";function s(){t.append(o());n=a(".ln-letters",t).slice(0,1);if(d.showCounts){k=a(".ln-letter-count",t).slice(0,1)}g();m();if(d.flagDisabled){p()}l();if(!d.includeAll){f.show()}if(!d.includeAll){a(".all",n).remove()}if(!d.includeNums){a("._",n).remove()}if(!d.includeOther){a(".-",n).remove()}a(":last",n).addClass("ln-last");if(a.cookie&&(d.cookieName!=null)){var A=a.cookie(d.cookieName);if(A!=null){d.initLetter=A}}if(d.initLetter!=""){c=true;a("."+d.initLetter.toLowerCase(),n).slice(0,1).click()}else{if(d.includeAll){a(".all",n).addClass("ln-selected")}else{for(var z=((d.includeNums)?0:1);z<e.length;z++){if(x[e[z]]>0){c=true;a("."+e[z],n).slice(0,1).click();break}}}}}function r(){k.css({top:a(".a",n).slice(0,1).offset({margin:false,border:true}).top-k.outerHeight({margin:true})})}function g(){var D,A,E,B,C,z=(d.prefixes.length>0);a(f).children().each(function(){C=a(this),A="",D=a.trim(C.text()).toLowerCase();if(D!=""){if(z){B=D.split(" ");if((B.length>1)&&(a.inArray(B[0],d.prefixes)>-1)){A=B[1].charAt(0);u(A,C,true)}}A=D.charAt(0);u(A,C)}})}function u(B,A,z){if(/[A-Z][a-z]/.test(B)){B="-"}if(!isNaN(B)){B="_"}A.addClass("ln-"+B);if(x[B]==undefined){x[B]=0}x[B]++;if(!z){i++}}function p(){for(var z=0;z<e.length;z++){if(x[e[z]]==undefined){a("."+e[z],n).addClass("ln-disabled")}}}function m(){f.append('<li class="ln-no-match" style="display:none">'+(AU.pageLang==="da"?"Ingen ord fundet med det valgte begyndelsesbogstav.":"No words found with the selected starting letter.")+"</li>")}function y(z){if(a(z).hasClass("all")){return i}else{var A=x[a(z).attr("class").split(" ")[0]];return(A!=undefined)?A:0}}function l(){if(d.showCounts){t.mouseover(function(){r()})}if(d.showCounts){a("a",n).mouseover(function(){var B=a(this).position().left;var z=(a(this).outerWidth({margin:true})-1)+"px";var A=y(this);k.css({left:B,width:z}).text(A).show()});a("a",n).mouseout(function(){k.hide()})}a("a",n).click(function(){a("a.ln-selected",n).removeClass("ln-selected");var A=a(this).attr("class").split(" ")[0];if(A=="all"){f.children().show();f.children(".ln-no-match").hide();j=true}else{if(j){f.children().hide();j=false}else{if(w!=""){f.children(".ln-"+w).hide()}}var z=y(this);if(z>0){f.children(".ln-no-match").hide();f.children(".ln-"+A).show()}else{f.children(".ln-no-match").show()}w=A}if(a.cookie&&(d.cookieName!=null)){a.cookie(d.cookieName,A)}a(this).addClass("ln-selected");a(this).blur();if(!c&&(d.onClick!=null)){d.onClick(A)}else{c=false}return false})}function o(){var A=[];for(var z=1;z<e.length;z++){if(A.length==0){A.push('<a class="all" href="#">&hellip;</a><!--<a class="_" href="#">0-9</a>-->')}A.push('<a class="'+e[z]+'" href="#">'+((e[z]=="-")?"...":e[z].toUpperCase())+"</a>")}return'<div class="ln-letters">'+A.join("")+"</div>"+((d.showCounts)?'<div class="ln-letter-count" style="display:none; position:absolute; top:0; left:0; width:20px;">0</div>':"")}s()})};a.fn.listnav.defaults={initLetter:"",includeAll:true,incudeOther:false,includeNums:true,flagDisabled:true,noMatchText:"",showCounts:true,cookieName:null,onClick:null,prefixes:[]}})(jQuery);

!function($){var Node,Tree,methods;Node=function(){function Node(row,tree,settings){var parentId;this.row=row,this.tree=tree,this.settings=settings,this.id=this.row.data(this.settings.nodeIdAttr),parentId=this.row.data(this.settings.parentIdAttr),null!=parentId&&""!==parentId&&(this.parentId=parentId),this.treeCell=$(this.row.children(this.settings.columnElType)[this.settings.column]),this.expander=$(this.settings.expanderTemplate),this.indenter=$(this.settings.indenterTemplate),this.children=[],this.initialized=!1,this.treeCell.prepend(this.indenter)}return Node.prototype.addChild=function(child){return this.children.push(child)},Node.prototype.ancestors=function(){var ancestors,node;for(node=this,ancestors=[];node=node.parentNode();)ancestors.push(node);return ancestors},Node.prototype.collapse=function(){return this.collapsed()?this:(this.row.removeClass("expanded").addClass("collapsed"),this._hideChildren(),this.expander.attr("title",this.settings.stringExpand),this.initialized&&null!=this.settings.onNodeCollapse&&this.settings.onNodeCollapse.apply(this),this)},Node.prototype.collapsed=function(){return this.row.hasClass("collapsed")},Node.prototype.expand=function(){return this.expanded()?this:(this.row.removeClass("collapsed").addClass("expanded"),this.initialized&&null!=this.settings.onNodeExpand&&this.settings.onNodeExpand.apply(this),$(this.row).is(":visible")&&this._showChildren(),this.expander.attr("title",this.settings.stringCollapse),this)},Node.prototype.expanded=function(){return this.row.hasClass("expanded")},Node.prototype.hide=function(){return this._hideChildren(),this.row.hide(),this},Node.prototype.isBranchNode=function(){return this.children.length>0||this.row.data(this.settings.branchAttr)===!0?!0:!1},Node.prototype.updateBranchLeafClass=function(){this.row.removeClass("branch"),this.row.removeClass("leaf"),this.row.addClass(this.isBranchNode()?"branch":"leaf")},Node.prototype.level=function(){return this.ancestors().length},Node.prototype.parentNode=function(){return null!=this.parentId?this.tree[this.parentId]:null},Node.prototype.removeChild=function(child){var i=$.inArray(child,this.children);return this.children.splice(i,1)},Node.prototype.render=function(){var handler,target,settings=this.settings;return settings.expandable===!0&&this.isBranchNode()&&(handler=function(e){return $(this).parents("table").treetable("node",$(this).parents("tr").data(settings.nodeIdAttr)).toggle(),e.preventDefault()},this.indenter.html(this.expander),target=settings.clickableNodeNames===!0?this.treeCell:this.expander,target.off("click.treetable").on("click.treetable",handler),target.off("keydown.treetable").on("keydown.treetable",function(e){13==e.keyCode&&handler.apply(this,[e])})),this.indenter[0].style.paddingLeft=""+this.level()*settings.indent+"px",this},Node.prototype.reveal=function(){return null!=this.parentId&&this.parentNode().reveal(),this.expand()},Node.prototype.setParent=function(node){return null!=this.parentId&&this.tree[this.parentId].removeChild(this),this.parentId=node.id,this.row.data(this.settings.parentIdAttr,node.id),node.addChild(this)},Node.prototype.show=function(){return this.initialized||this._initialize(),this.row.show(),this.expanded()&&this._showChildren(),this},Node.prototype.toggle=function(){return this.expanded()?this.collapse():this.expand(),this},Node.prototype._hideChildren=function(){var child,_i,_len,_ref,_results;for(_ref=this.children,_results=[],_i=0,_len=_ref.length;_len>_i;_i++)child=_ref[_i],_results.push(child.hide());return _results},Node.prototype._initialize=function(){var settings=this.settings;return this.render(),settings.expandable===!0&&"collapsed"===settings.initialState?this.collapse():this.expand(),null!=settings.onNodeInitialized&&settings.onNodeInitialized.apply(this),this.initialized=!0},Node.prototype._showChildren=function(){var child,_i,_len,_ref,_results;for(_ref=this.children,_results=[],_i=0,_len=_ref.length;_len>_i;_i++)child=_ref[_i],_results.push(child.show());return _results},Node}(),Tree=function(){function Tree(table,settings){this.table=table,this.settings=settings,this.tree={},this.nodes=[],this.roots=[]}return Tree.prototype.collapseAll=function(){var node,_i,_len,_ref,_results;for(_ref=this.nodes,_results=[],_i=0,_len=_ref.length;_len>_i;_i++)node=_ref[_i],_results.push(node.collapse());return _results},Tree.prototype.expandAll=function(){var node,_i,_len,_ref,_results;for(_ref=this.nodes,_results=[],_i=0,_len=_ref.length;_len>_i;_i++)node=_ref[_i],_results.push(node.expand());return _results},Tree.prototype.findLastNode=function(node){return node.children.length>0?this.findLastNode(node.children[node.children.length-1]):node},Tree.prototype.loadRows=function(rows){var node,row,i;if(null!=rows)for(i=0;i<rows.length;i++)row=$(rows[i]),null!=row.data(this.settings.nodeIdAttr)&&(node=new Node(row,this.tree,this.settings),this.nodes.push(node),this.tree[node.id]=node,null!=node.parentId&&this.tree[node.parentId]?this.tree[node.parentId].addChild(node):this.roots.push(node));for(i=0;i<this.nodes.length;i++)node=this.nodes[i].updateBranchLeafClass();return this},Tree.prototype.move=function(node,destination){var nodeParent=node.parentNode();return node!==destination&&destination.id!==node.parentId&&-1===$.inArray(node,destination.ancestors())&&(node.setParent(destination),this._moveRows(node,destination),1===node.parentNode().children.length&&node.parentNode().render()),nodeParent&&nodeParent.updateBranchLeafClass(),node.parentNode()&&node.parentNode().updateBranchLeafClass(),node.updateBranchLeafClass(),this},Tree.prototype.removeNode=function(node){return this.unloadBranch(node),node.row.remove(),null!=node.parentId&&node.parentNode().removeChild(node),delete this.tree[node.id],this.nodes.splice($.inArray(node,this.nodes),1),this},Tree.prototype.render=function(){var root,_i,_len,_ref;for(_ref=this.roots,_i=0,_len=_ref.length;_len>_i;_i++)root=_ref[_i],root.show();return this},Tree.prototype.sortBranch=function(node,sortFun){return node.children.sort(sortFun),this._sortChildRows(node),this},Tree.prototype.unloadBranch=function(node){var i,children=node.children.slice(0);for(i=0;i<children.length;i++)this.removeNode(children[i]);return node.children=[],node.updateBranchLeafClass(),this},Tree.prototype._moveRows=function(node,destination){var i,children=node.children;for(node.row.insertAfter(destination.row),node.render(),i=children.length-1;i>=0;i--)this._moveRows(children[i],node)},Tree.prototype._sortChildRows=function(parentNode){return this._moveRows(parentNode,parentNode)},Tree}(),methods={init:function(options,force){var settings;return settings=$.extend({branchAttr:"ttBranch",clickableNodeNames:!1,column:0,columnElType:"td",expandable:!1,expanderTemplate:"<a href='#'>&nbsp;</a>",indent:19,indenterTemplate:"<span class='indenter'></span>",initialState:"collapsed",nodeIdAttr:"ttId",parentIdAttr:"ttParentId",stringExpand:"Expand",stringCollapse:"Collapse",onInitialized:null,onNodeCollapse:null,onNodeExpand:null,onNodeInitialized:null},options),this.each(function(){var tree,el=$(this);return(force||void 0===el.data("treetable"))&&(tree=new Tree(this,settings),tree.loadRows(this.rows).render(),el.addClass("treetable").data("treetable",tree),null!=settings.onInitialized&&settings.onInitialized.apply(tree)),el})},destroy:function(){return this.each(function(){return $(this).removeData("treetable").removeClass("treetable")})},collapseAll:function(){return this.data("treetable").collapseAll(),this},collapseNode:function(id){var node=this.data("treetable").tree[id];if(!node)throw new Error("Unknown node '"+id+"'");return node.collapse(),this},expandAll:function(){return this.data("treetable").expandAll(),this},expandNode:function(id){var node=this.data("treetable").tree[id];if(!node)throw new Error("Unknown node '"+id+"'");return node.initialized||node._initialize(),node.expand(),this},loadBranch:function(node,rows){var settings=this.data("treetable").settings,tree=this.data("treetable").tree;if(rows=$(rows),null==node)this.append(rows);else{var lastNode=this.data("treetable").findLastNode(node);rows.insertAfter(lastNode.row)}return this.data("treetable").loadRows(rows),rows.filter("tr").each(function(){tree[$(this).data(settings.nodeIdAttr)].show()}),null!=node&&node.render().expand(),this},move:function(nodeId,destinationId){var destination,node;return node=this.data("treetable").tree[nodeId],destination=this.data("treetable").tree[destinationId],this.data("treetable").move(node,destination),this},node:function(id){return this.data("treetable").tree[id]},removeNode:function(id){var node=this.data("treetable").tree[id];if(!node)throw new Error("Unknown node '"+id+"'");return this.data("treetable").removeNode(node),this},reveal:function(id){var node=this.data("treetable").tree[id];if(!node)throw new Error("Unknown node '"+id+"'");return node.reveal(),this},sortBranch:function(node,columnOrFunction){var sortFun,settings=this.data("treetable").settings;return columnOrFunction=columnOrFunction||settings.column,sortFun=columnOrFunction,$.isNumeric(columnOrFunction)&&(sortFun=function(a,b){var extractValue,valA,valB;return extractValue=function(node){var val=node.row.find("td:eq("+columnOrFunction+")").text();return $.trim(val).toUpperCase()},valA=extractValue(a),valB=extractValue(b),valB>valA?-1:valA>valB?1:0}),this.data("treetable").sortBranch(node,sortFun),this},unloadBranch:function(node){return this.data("treetable").unloadBranch(node),this}},$.fn.treetable=function(method){return methods[method]?methods[method].apply(this,Array.prototype.slice.call(arguments,1)):"object"!=typeof method&&method?$.error("Method "+method+" does not exist on jQuery.treetable"):methods.init.apply(this,arguments)},window.TreeTable||(window.TreeTable={}),window.TreeTable.Node=Node,window.TreeTable.Tree=Tree}(jQuery);